export default "{\n    \"inputPlaceholder\": \"Type your message\",\n    \"uploadFileLabel\": \"Upload from Device\"\n}\n"